import SaveScheduleTemplateCtrl from './SaveScheduleTemplateCtrl';
import modalSaveTemplateUrl from './modal-save-template.html';
import LoadScheduleTemplateCtrl from './LoadScheduleTemplateCtrl';
import modalLoademplateUrl from './modal-load-template.html';

export default class ScheduleTemplateService {
  constructor(Authentication, EventCollection, Utils, extendShiftModel, sdk, $uibModal) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      EventCollection,
      Utils,
      extendShiftModel,
      sdk,
      $uibModal,
    });
  }
  saveScheduleTemplate({ shiftIds, mode, days }) {
    if (!this.Authentication.user.org.isPremium) {
      return;
    }

    const actionableDict = shiftIds.reduce((acc, id) => ((acc[id] = true), acc), {});
    let shifts = this.EventCollection.allEvents
      .filter((e) => e.id in actionableDict && e.type === this.sdk('constants').SHIFT_TYPE)
      .map(this.extendShiftModel)
      .filter((e) => e.duration > 0); // discard ad-hoc clock-in derivative shifts

    if (mode === 'day') {
      const { visibleHoursStart, visibleHoursEnd } = this.Authentication.user.orgSettings;
      const getBusinessDayStart = (dtstart) =>
        this.Utils.getBusinessDayStart(visibleHoursStart, visibleHoursEnd, dtstart);
      shifts = shifts.filter(
        (shift) => this.Utils.formatDate(getBusinessDayStart(shift.dtstart)) === days[0]
      );
    }

    this.$uibModal.open({
      controller: SaveScheduleTemplateCtrl,
      controllerAs: 'ctrl',
      size: '620',
      templateUrl: modalSaveTemplateUrl,
      resolve: {
        mode: () => mode,
        dateFrom: () => days[0],
        dateTo: () => days[days.length - 1],
        shifts: () => shifts,
      },
    });
  }
  loadScheduleTemplate({ mode, days }) {
    if (!this.Authentication.user.org.isPremium) {
      return;
    }

    this.$uibModal.open({
      controller: LoadScheduleTemplateCtrl,
      controllerAs: 'ctrl',
      size: '620',
      templateUrl: modalLoademplateUrl,
      resolve: {
        mode: () => mode,
        date: () => days[0],
      },
    });
  }
}
